<template>
  <div class="strip-bg">
    <div class="steps-carousel relative lg-container">
      <div class="container position-relative p-0">
        <ul class="steps-titles" :style="{ transform: `translateX(-${currentIndex * 25}%)` }">
          <li v-for="(step, index) in stepsData[0]?.steps"
              :key="step._id"
              :class="{ 'is-active': index === currentIndex, 'is-past': index < currentIndex }">
            {{ step.title }}
            <svg v-if="index < stepsData[0]?.steps.length - 1"
                 xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 640 640"
                 class="steps-next"
                 :class="{ 'is-disabled': index !== currentIndex }"
                 @click="index === currentIndex && nextStep()">
              <path d="M439.1 297.4C451.6 309.9 451.6 330.2 439.1 342.7L279.1 502.7C266.6 515.2 246.3 515.2 233.8 502.7C221.3 490.2 221.3 469.9 233.8 457.4L371.2 320L233.9 182.6C221.4 170.1 221.4 149.8 233.9 137.3C246.4 124.8 266.7 124.8 279.2 137.3L439.2 297.3z"/>
            </svg>
          </li>
        </ul>
        <div class="steps-carousel-inner" :style="{ transform: `translateX(-${currentIndex * 25}%)` }">
          <div v-for="step in stepsData[0]?.steps" :key="step._id" class="steps-item d-flex align-items-center justify-content-center" :class="`step--${step.title.toLowerCase()}`">
            <div class="row h-100 m-0 p-0 align-items-center">
              <div class="steps-image-col col-12 col-md-6 align-items-center">
                <img src="../../assets/images/logo/cross-white.svg"
                     alt=""
                     class="steps-cross"
                     height="40"
                     width="40">
                <div v-if="step.image" class="steps-image-wrapper position-relative">
                  <img :src="urlFor(step.image?.image?.asset.url)"
                       :alt="step.image?.alt"
                       class="steps-image" />
                </div>
              </div>
              <div class="steps-text-col col-12 col-md-6">
                <img :src="urlFor(step.icon?.image?.asset.url)"
                     :alt="step.icon?.alt"
                     height="50"
                     width="50"
                     class="steps-icon" />
                <h3>{{ step.subheading }}</h3>
                <p>{{ step.cta }}</p>
                <a href="mailto:sales@marshallprint.co.uk?subject=Inquiry&body=---%0AContext: Home page Steps Carousel link"
                   class="btn btn-primary steps-cta-btn">
                  Get in touch
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="steps-nav">
          <button
              class="steps-nav__prev position-relative"
              :disabled="currentIndex === 0"
              @click="prevStep">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
              <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
            </svg>
          </button>
          <button
              class="steps-nav__next position-relative"
              :disabled="stepsData[0]?.steps && currentIndex === stepsData[0].steps.length - 1"
              @click="nextStep">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
              <path d="M247.1 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L179.2 256 41.9 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sanity from "../../../sanity";
import {urlFor} from "@/mixins/sanityImageMixin";
export default {
  name: 'StepsCarousel',
  data() {
    return {
      stepsData: [],
      currentIndex: 0
    };
  },
  async created() {
    this.stepsData = await sanity.fetch(`*[_type == "stepsCarousel"]{
      _id,
      title,
      steps[]{
        title,
        subheading,
        cta,
        icon{
          alt,
          image{
            asset->{
              url,
              metadata{
                dimensions{
                  height,
                  width
                }
              }
            }
          }
        },
        image{
          alt,
          image{
            asset->{
              url,
              metadata{
                dimensions{
                  height,
                  width
                }
              }
            }
          }
        }
      }
    }`);
  },
  methods: {
    urlFor,
    nextStep() {
      if (this.stepsData[0]?.steps && this.currentIndex < this.stepsData[0].steps.length - 1) {
        this.currentIndex++;
      }
    },
    prevStep() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.strip-bg {
  background: linear-gradient(90deg, var(--pink) 0%, var(--pink) 50%, var(--green) 50%, var(--green) 100%);
  margin: 0;
  padding: 0;
  position: relative;
}
.steps-carousel {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: hidden;
  width: 100%;
}
.steps-carousel-inner {
  display: flex;
  flex-direction: row;
  position: relative;
  scroll-snap-type: x mandatory;
  width: 360%;
  transition: transform 0.3s ease-in-out;
  @media (max-width: 991px) {
    width: 380%;
  }
}
.steps-item {
  color: var(--white);
  height: 45rem;
  position: relative;
  width: 90%;
  @media (max-width: 991px) {
    height: 35rem;
    width: 95%;
  }
}

.steps-cta-btn {
  bottom: 4rem;
  display: none;
  position: absolute;
  right: 4rem;
  @media (max-width: 991px) {
    bottom: 1rem;
    right: 0.5rem;
  }
}
.step--create {
  background-color: var(--lightblue);
}
.step--precision {
  background-color: var(--pink);
}
.step--install {
  background-color: var(--orange);
}
.step--display {
  background-color: var(--green);
  .steps-cta-btn {
    display: inline-block;
  }
}
.steps-item h2 {
  color: var(--white);
}
.steps-item h3 {
  color: var(--black);
  font-size: 2.25rem;
  font-weight: bold;
  @media (max-width: 991px) {
    font-size: 1.75rem;
  }
}
.steps-image-col {
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
}

.steps-image-wrapper {
  display: inline-block;
  position: relative;
  @media (max-width: 991px) {
    top: 2rem;
  }
}

.steps-item .steps-image-wrapper:after {
  color: var(--white);
  display: block;
  font-size: 6rem;
  font-weight: bold;
  position: absolute;
  left: -3rem;
  bottom: -0.5rem;
  z-index: 10;
  @media (max-width: 991px) {
   font-size: 3rem;
    left: -1rem;
  }
  @media (max-width: 1200px) {
    font-size: 4.5rem;
    left: -2rem;
  }
}
.steps-item:nth-child(1) .steps-image-wrapper:after {
  content: "01";
}
.steps-item:nth-child(2) .steps-image-wrapper:after {
  content: "02";
}
.steps-item:nth-child(3) .steps-image-wrapper:after {
  content: "03";
}
.steps-item:nth-child(4) .steps-image-wrapper:after {
  content: "04";
}
.steps-image {
  max-width: 100%;
  height: 25rem;
  position: relative;
  width: 25rem;
  z-index: 10;
  @media (max-width: 991px) {
    height: 12rem;
    width: 12rem;
  }
  @media (max-width: 1200px) {
    height: 18rem;
    width: 18rem;
  }
}
.steps-item .steps-image-wrapper:before {
  content: "";
  background-color: var(--white);
  display: block;
  opacity: 0.3;
  width: 15rem;
  height: 15rem;
  position: absolute;
  right: -3rem;
  top: -3rem;
  z-index: 5;
  @media (max-width: 991px) {
    width: 8rem;
    height: 8rem;
    right: -2rem;
    top: -2rem;
  }
  @media (max-width: 1200px) {
    width: 10rem;
    height: 10rem;
    right: -2rem;
    top: -2rem;
  }
}
.steps-cross {
  position: absolute;
  top: 6rem;
  left: 6rem;
  z-index: 10;
  @media (max-width: 991px) {
    top: 0;
    left: 1rem;
  }
}
.steps-text-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 2rem;
}
.steps-text-col h3, .steps-text-col p {
  display: block;
  max-width: 35rem;
  position: relative;
}
.steps-text-col h3 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  @media (max-width: 991px) {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
}

.steps-text-col p {
  font-size: 1.5rem;
  line-height: 1.5;
  height: 3rem;
  @media (max-width: 991px) {
    font-size: 1rem;
    margin: 0 0 2rem 0;
  }
}

.steps-icon {
  display: block;
  filter: invert(1) brightness(1) saturate(1);
  height: 3rem;
  margin-bottom: 8rem;
  width: 3rem;
  @media (max-width: 991px) {
    height: 2rem;
    margin-bottom: 4rem;
    width: 2rem;
  }
}
.steps-icon path {
  display: block;
}
.steps-titles {
  align-items: center;
  color: var(--white);
  display: flex;
  flex-direction: row;
  font-size: 4rem;
  font-weight: bold;
  left: 48.5%;
  line-height: 4rem;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 16rem;
  transition: transform 0.3s ease-in-out;
  z-index: 50;
  @media (max-width: 991px) {
    font-size: 2rem;
    left: 2.5rem;
    line-height: 2rem;
    top: 20rem;
  }
}
.steps-titles li {
  display: flex;
  align-items: center;
  margin-right: 0;
  padding-right: 2rem;
  opacity: 0.4;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  width: 25rem;
  @media (max-width: 991px) {
    width: 13rem;
  }
}

.steps-titles li.is-active {
  opacity: 1;
  transform: scale(1.1);
}

.steps-titles li.is-past {
  opacity: 0.6;
}

.steps-next {
  fill: var(--white);
  width: 4rem;
  height: 4rem;
  margin: 1rem 0 0 1rem;
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;
  @media (max-width: 991px) {
    width: 2rem;
    height: 2rem;
    margin: 0.5rem 0 0 0.5rem;
  }
}

.steps-next.is-disabled {
  opacity: 0.3;
  cursor: not-allowed;
  pointer-events: none;
}

.steps-next:not(.is-disabled) {
  opacity: 1;
}

.steps-nav {
  bottom: 1rem;
  display: flex;
  height: 2rem;
  justify-content: center;
  left: 1rem;
  position: absolute;
  width: 6rem;
  @media (max-width: 991px) {
    bottom: 0;
    left: 0.5rem;
    height: 3rem;
  }
  .steps-nav__prev,
  .steps-nav__next {
    display: block;
    fill: var(--white);
    height: 2rem;
    margin: 0 1rem;
    width: 1rem;
    @media (max-width: 600px) {
      height: 2rem;
      margin: 0 0.5rem;
      width: 1rem;
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}

</style>
